import { BehaviorSubject } from 'rxjs/Rx';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { CookieService } from 'app/services/cookie.service';
import { ConstantsService } from 'app/services/constants-service';
import { ObservableRequestService } from 'app/services/observable-request.service';

import { Task } from 'app/shared/models/task.model';

/**
 * Service for task component.
 */
@Injectable()
export class TaskService {
  private broadCastMeaasge = new BehaviorSubject<string>('old');
  currentMessage = this.broadCastMeaasge.asObservable();
  constructor(
    private requestService: ObservableRequestService,
    private cookieService: CookieService) {
  }

  fetchTasks(entityId: Number): Observable<any> {
    return this.requestService.getRequest(`${ConstantsService.TASKS_ENDPOINT}/${entityId}`);
  }

  addTask(task: Task): Observable<any> {
    return this.requestService.postRequest(
      ConstantsService.TASKS_ENDPOINT,
      JSON.stringify(task),
      this.requestService.getJSONContentType());
  };

  updateTask(task: Task): Observable<any> {
    return this.requestService.putRequest(
      ConstantsService.TASKS_ENDPOINT,
      JSON.stringify(task),
      this.requestService.getJSONContentType());
  };

  delegateTask(task: any): Observable<any> {
    return this.requestService.postRequest(
      ConstantsService.TASK_DELEGATE_ENDPOINT,
      JSON.stringify(task),
      this.requestService.getJSONContentType());
  };

  submitTask(task: Task): Observable<any> {
    return this.requestService.postRequest(
      ConstantsService.TASK_SUBMIT_ENDPOINT,
      JSON.stringify(task),
      this.requestService.getJSONContentType());
  };

  resolveTask(task: any): Observable<any> {
    return this.requestService.postRequest(
      ConstantsService.TASK_RESOLVE_ENDPOINT,
      JSON.stringify(task),
      this.requestService.getJSONContentType());
  };

  getTaskGuide(taskDefId: string): Observable<any> {
    return this.requestService.getRequest(
      `${ConstantsService.TASK_GUIDE_ENDPOINT}/${taskDefId}`);
  };

  addComment(body: Object): Observable<any> {
    return this.requestService.postRequest(
      ConstantsService.TASK_COMMENT_ENDPOINT,
      JSON.stringify(body),
      this.requestService.getJSONContentType());
  };

  removeComment(commentId: string): Observable<any> {
    return this.requestService.deleteRequest(ConstantsService.TASK_COMMENT_ENDPOINT,
      this.requestService.serialize({ commentId: commentId }),
      this.requestService.getFormEncodedContentType());
  }

  submitTaskChoice(body: Object): Observable<any> {
    return this.requestService.postRequest(
      ConstantsService.TASK_SUBMIT_CHOICE_ENDPOINT,
      JSON.stringify(body),
      this.requestService.getJSONContentType()).map(body => {
      console.log('body service map VALUE::::: ', body);
      return body;
    });
  }

  getActiveWorkFlows(entityID: Number): Observable<any> {
    return this.requestService.getRequest(
      `${ConstantsService.ACTIVE_WORKFLOWS}/${entityID}`);
  };

  cancelWorkflow(entityID: Number, activeWorkId: Number, reasonToCancel: String): Observable<any> {
    return this.requestService.deleteRequest(
      `${ConstantsService.CANCEL_WORKFLOW}/${entityID}/${activeWorkId}/${reasonToCancel}`, '', this.requestService.getJSONContentType());
  };

  sendMessage(message: string) {
    this.broadCastMeaasge.next(message);
  }


  getClientStateStatus(clientid: Number): Observable<any> {
    return this.requestService.getRequest(
      `${ConstantsService.CLIENTS_ENDPOINT}/${clientid}${ConstantsService.CLIENTS_STATES_ENDPOINT}`);
  };

  updateClientStateStatus(clientid: Number, clientNewStateStatus: string): Observable<any> {
    let fromdata = {
      clientid: clientid,
      clientStateStatus: clientNewStateStatus
    }
    return this.requestService.putRequest(
      `${ConstantsService.CLIENTS_ENDPOINT}${ConstantsService.CLIENTS_STATES_ENDPOINT}`,
      this.requestService.serialize(fromdata),
      this.requestService.getFormEncodedContentType());
  }


}



// WEBPACK FOOTER //
// ./src/app/task/task.service.ts